var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('topup-auto-progress'),(_vm.isStageActive(1))?_c('topup-auto-stage1'):_vm._e(),(_vm.isStageActive(2))?_c('topup-auto-stage2'):_vm._e(),(_vm.isStageActive(4))?_c('topup-auto-stage4'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }